<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="localValue"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="localValue"
            :label="label ? label : 'Picker in menu'"
            outlined
            dense
            append-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu"
          v-model="localValue"
          full-width
          format="24hr"
          @click:minute="$refs.menu.save(localValue)"
        ></v-time-picker>
      </v-menu>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "Timepicker",
  props: {
    label: {
      require: true,
    },
    value: {
      require: true,
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "time-picker",
      menu: false,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  max-height: unset !important;
}
</style>
